import type { GetDocumentOversightResultByIdResponseRow } from '@risksmart-app/drizzle/src/types';
import type { GetDocumentOversightResultByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetDocumentOversightResultByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetDocumentOversightResultByIdArgs = { id: string };

export const useGetDocumentOversightResultById = createQueryHook<
  UseGetDocumentOversightResultByIdArgs,
  GetDocumentOversightResultByIdResponseRow[],
  GetDocumentOversightResultByIdQuery
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.assessment.documentOversightResultById.queryOptions({ id }),
  mapTrpcDataToGraphQL: (data) => ({ document_oversight_result: data }),
  graphqlDocument: GetDocumentOversightResultByIdDocument,
  graphqlVariables: ({ id }) => ({ Id: id }),
});
